export const ngDeps = {};

export function injectNgDeps(deps) {
  Object.assign(ngDeps, deps);
}

export const useNgDeps = () => ({ ngDeps, injectNgDeps });

export default ngDeps;
